
// initial state
// shape: [{ id, quantity }]
const state = () => ({
  isEditFormVisible: false,
  isPreviewWinVisible: false,
  isPostDialogVisible: false,
  activeDoc: null,

  isNotificationBarVisible: false,
  notificationLevel: 'INFO',
  notificationMsg: 'Default Text of UI Store',
})


// this.$store.dispatch('ui/setEditForm', val)
const actions = {

  resetActiveDoc ({ commit }) {
    commit('setPreviewWinVisible', false)
    commit('setEditFormVisible', false)
    commit('setActiveDoc', null)
  },

  raiseInfo({commit}, msg) {
    console.log(`!! raiseInfo ${msg}`);
    commit('setNotification', {
      level: 'INFO',
      message: msg
    });
  },

  raiseError({commit}, msg) {
    console.log(`!! raiseError ${msg}`);
    commit('setNotification', {
      level: 'ERROR',
      message: msg
    });
  },

  dismissError({commit}) {
    commit('resetNotification');
  },

  // EditForm
  showEditForm ({ commit }, url_hash) {
    commit('setActiveDoc', url_hash)
    commit('setEditFormVisible', true)
  },
  closeEditForm ({ commit }) {
    commit('setEditFormVisible', false)
    // commit('setActiveDoc', null)
  },

  // PreviewWin
  showPreviewWin ({ commit }, url_hash) {
    commit('setActiveDoc', url_hash)
    commit('setPreviewWinVisible', true)    
  },
  closePreviewWin ({ commit }) {
    commit('setPreviewWinVisible', false)    
  },

  // PostDialog
  showPostDialog ({ commit }) {
    commit('setPostDialogVisible', true)    
  },
  closePostDialog ({ commit }) {
    commit('setPostDialogVisible', false)    
  },


  // lower level
  setEditForm ({ commit }, val) {
    commit('setEditFormVisible', val);
  },
  setPreviewWin ({ commit }, val) {
    commit('setPreviewWinVisible', val);
  },
  setPostDialog ({ commit }, val) {
    commit('setPostDialogVisible', val);
  },
}


const mutations = {
  setActiveDoc (state, val) {
    // console.log('=> commit ui/setActiveDoc');
    // console.log(`val: ${val}`);
    state.activeDoc = val
  },

  setEditFormVisible (state, val) {
    // console.log('=> commit ui/setEditFormVisible');
    // console.log(`val: ${val}`);
    state.isEditFormVisible = val;
  },

  setPreviewWinVisible(state, val) {
    state.isPreviewWinVisible = val;
  },

  setPostDialogVisible(state, val) {
    state.isPostDialogVisible = val;
  },

  setNotification(state, notificationData) {
    state.notificationLevel = notificationData.level;
    state.notificationMsg = notificationData.message;
    state.isNotificationBarVisible = true;
  },

  resetNotification(state) {
    state.isNotificationBarVisible = false;
    state.notificationLevel = null;
    state.notificationMsg = null;
  },

}


const getters = {

  activeDoc: state => {
    return state.activeDoc
  },
  isEditFormVisible: state => {
    return state.isEditFormVisible
  },
  isPreviewWinVisible: state => {
    return state.isPreviewWinVisible
  },
  isPostDialogVisible: state => {
    return state.isPostDialogVisible
  },

  isNotificationBarVisible: state => {
    return state.isNotificationBarVisible
  },
  notificationMsg: state => {
    return state.notificationMsg
  },
  notificationLevel: state => {
    return state.notificationLevel
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// RANDOM STUFF

// pushProductToCart (state, { id }) {
//   state.items.push({
//     id,
//     quantity: 1
//   })
// },

// addProductToCart ({ state, commit }, product) {
//   commit('setCheckoutStatus', null)
//   if (product.inventory > 0) {
//     const cartItem = state.items.find(item => item.id === product.id)
//     if (!cartItem) {
//       commit('pushProductToCart', { id: product.id })
//     } else {
//       commit('incrementItemQuantity', cartItem)
//     }
//     // remove 1 item from stock
//     commit('products/decrementProductInventory', { id: product.id }, { root: true })
//   }
// }

// mindsync.fetchItem(
//   products,
//   () => commit('setCheckoutStatus', 'successful'),
//   () => {
//     commit('setCheckoutStatus', 'failed')
//     // rollback to the cart saved before sending the request
//     commit('setCartItems', { items: savedCartItems })
//   }
// )

